module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatDisorder/Kanagawa_HeatDisorder_GFDL_RCP26_End.png";